import { render, staticRenderFns } from "./EditShippingTable.vue?vue&type=template&id=6b801ad7&scoped=true&"
import script from "./EditShippingTable.vue?vue&type=script&lang=js&"
export * from "./EditShippingTable.vue?vue&type=script&lang=js&"
import style0 from "./EditShippingTable.vue?vue&type=style&index=0&id=6b801ad7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b801ad7",
  null
  
)

component.options.__file = "EditShippingTable.vue"
export default component.exports